import { IThemeAssetContributor } from '../ThemeAssetContributor';
import { AppConsts } from '@shared/AppConsts';

export class Theme2ThemeAssetContributor implements IThemeAssetContributor {
  public getAssetUrls(): string[] {
    return [
      AppConsts.appBaseUrl + '/assets/fonts/fonts-asap-condensed.min.css',
    ];
  }

  public getAdditionalBodyStle(): string {
    return '';
  }

  public getMenuWrapperStyle(): string {
    return 'header-menu-wrapper header-menu-wrapper-left';
  }

  public getSubheaderStyle(): string {
    return 'text-white font-weight-bold my-2 mr-5';
  }

  public getFooterStyle(): string {
    return 'footer bg-white py-4 d-flex flex-lg-column';
  }
}
